<template>
    <div class="dashboard-container" ref="dashboardContainer">
        <router-view />
    </div>
</template>

<script>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

export default {

    setup() {
        const dashboardContainer = ref(null);
        const route = useRoute();

        watch(() => route.path, () => {
            if (dashboardContainer.value) {
                dashboardContainer.value.scrollTop = 0;
            }
        });

        return {
            dashboardContainer,
        };
    },
};
</script>

<style scoped lang="scss">
    @import '../assets/styles/DashboardContainer.scss'
</style>